module.exports = __webpack_public_path__ + "static/img/Partner15@2x.0fb38c28.png";